import type { FC } from "react";
import { Button } from "@similarweb/ui-components";
import {
    StyledModalErrorContainer,
    StyledModalErrorCTAWrapper,
    StyledModalErrorDescription,
    StyledModalErrorTitle,
    StyledModalErrorTitleContainer,
    StyledModalIconWrapper,
} from "./styles";
import { SWReactIcons } from "@similarweb/icons";

type ModalContentErrorProps = {
    title: string;
    description: string;
    onClick: () => void;
    buttonText: string;
};
const ModalContentError: FC<ModalContentErrorProps> = ({ title, description, onClick, buttonText }) => {
    return (
        <StyledModalErrorContainer>
            <StyledModalErrorTitleContainer>
                <StyledModalIconWrapper>
                    <SWReactIcons
                        iconName="alert-circle"
                        size="sm"
                    />
                </StyledModalIconWrapper>
                <StyledModalErrorTitle>{title}</StyledModalErrorTitle>
            </StyledModalErrorTitleContainer>
            <StyledModalErrorDescription>{description}</StyledModalErrorDescription>
            <StyledModalErrorCTAWrapper>
                <Button
                    type="primary"
                    onClick={onClick}
                >
                    {buttonText}
                </Button>
            </StyledModalErrorCTAWrapper>
        </StyledModalErrorContainer>
    );
};

export default ModalContentError;
